<template>
	<div>
		<Modal 
		:loading="loading" 
		:title="current != 'new' ? 'EDITAR CLIENTE' : 'NOVO CLIENTE'"
		@close="close"
		@save="save">
            <div class="row">
				<div class="col-xs">
					<small><b>Informações gerais</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<FormSelect v-model="status" label="Status" :options="options.status" :required="true" tooltip="Selecione o status do cliente" ref="status" />
				</div>
				<div class="col-xs-12" :class="client_atak ? 'col-lg-6' : 'col-lg-12'">
					<FormInputMasked v-model="document" label="CPF/CNPJ" type="tel" :required="true" :mask="['###.###.###-##', '##.###.###/####-##']" :disabled="current != 'new' ? true : false" tooltip="Informe o documento de identificação do cliente" ref="document" />
				</div>
                <div v-if="client_atak" class="col-xs-12 col-lg-6">
					<FormInput v-model="code" label="Código do cliente" type="tel" :required="false" tooltip="Informe o código do cliente ('chave de fato' do registro do cliente no sistema integrado)" ref="code" />
				</div>
                <div v-if="client_atak" class="col-xs-12 col-lg-6">
					<FormSelect v-model="code_registration_type" label="Código do tipo de cadastro" :options="options.code_registration_type" :required="false" tooltip="Informe o código do tipo de cadastro ('id do tipo de cadastro' do registro do cliente no sistema integrado)" ref="code_registration_type" />
				</div>
            </div>
            <div class="row">
				<div class="col-xs-12 col-lg-12">
					<FormInput v-model="name" label="Nome" type="text" :required="true" tooltip="Informe o nome do cliente" ref="name" />
				</div>
			</div>
            <div class="row">
				<div class="col-xs">
					<small><b>Informações de endereço</b></small>
				</div>
			</div>
			<form-group-address
				:current_id="id"
				:current_postal_code="postal_code"
				:current_street="street"
				:current_number="number"
				:current_complement="complement"
				:current_neighborhood="neighborhood"
				:current_city="city"
				:current_uf="uf"
				:current_country="country"
				:current_coordinates="coordinates"
				ref="formGroup"
			>
			</form-group-address>
			<div class="row">
				<div class="col-xs">
					<small><b>Informações de contato</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-4">
                    <FormInputMasked v-model="phone" label="Telefone" type="tel" :required="false" :mask="['(##) ####-####', '+## (##) #####-####']" tooltip="Informe o número de telefone para contato" ref="phone" />
				</div>
				<div class="col-xs-12 col-lg-4">
                    <FormInputMasked v-model="contact_mobile" label="Whatsapp" type="tel" :required="false" :mask="['(##) ####-####', '+## (##) #####-####']" tooltip="Informe o número do Whatsapp para contato" ref="contact_mobile" />
				</div>
				<div class="col-xs-12 col-lg-4">
					<FormInput v-model="contact_email" label="E-mail" type="email" :required="false" tooltip="Informe o e-mail para contato" ref="contact_email" />
				</div>
			</div>
            <div class="row">
				<div class="col-xs">
					<small><b>Informações de roteirização</b></small>
				</div>
			</div>
            <div class="row">
                <div class="col-xs-12 col-lg-6">
                    <FormInputMasked type="tel" label="Tempo médio de descarregamento" v-model="average_discharge_time" :mask="['# min','## min','### min','#### min','##### min']" tooltip="Informe o tempo médio que leva para descarregar entregas neste cliente (seja por questão de espaço, localidade, horário, etc)" ref="average_discharge_time" />
                </div>
				<div class="col-xs-12">
					<FormCheckbox v-model="discharge_timer" label="Horário de Descarregamento" tooltip="Habilitar a função de descarregamento por horário" ref="discharge_timer" />
				</div>
				<div class="row" v-if="discharge_timer">
					<div class="col-lg-6" v-for="(day, dayIndex) in Object.keys(delivery_days)" :key="dayIndex">
						<div class="d-flex justify-between">
							{{ days_of_week(day) }}
							<i class="fas fa-plus" @click="add_timer(day)" v-if="(delivery_days[day].length < 3)"></i>
						</div>
						<div class="row" v-for="(hours, hoursIndex) in delivery_days[day]" :key="hoursIndex">
							<div class="col-lg-5">
								<FormInputMasked v-model="delivery_days[day][hoursIndex].start" label="Hora Inicial" type="text" :mask="['##:##']" ref="start_time" />
							</div>
							<div class="col-lg-5">
								<FormInputMasked v-model="delivery_days[day][hoursIndex].end" label="Hora Final" type="text" :mask="['##:##']" ref="end_time" />
							</div>
							<i class="fas fa-times" @click="remove_timer(day, hoursIndex)" v-if="(delivery_days[day].length > 1)"></i>
						</div>
					</div>
				</div>
            </div>
		</Modal>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormGroupAddress from '@/components/FormGroupAddress.vue';
import FormSelect from "@/components/FormSelect";
import FormCheckbox from "@/components/FormCheckbox";

export default {
	name: "CustomerForm",

	props: {
		current: {
			type: [Object, String],
			required: true,
		},
	},

	components: {
		Modal,
		FormInput,
		FormInputMasked,
		FormGroupAddress,
		FormSelect,
		FormCheckbox
	},

	data: function() {
		console.log(this.current);
		const defaultDays = {
			segunda: [{ start: "", end: "" }],
			terca: [{ start: "", end: "" }],
			quarta: [{ start: "", end: "" }],
			quinta: [{ start: "", end: "" }],
			sexta: [{ start: "", end: "" }],
			sabado: [{ start: "", end: "" }],
			domingo: [{ start: "", end: "" }]
		};

		if (this.current != "new") {
			return {
				loading: false,
                
                id: this.current.id,
				status: this.current.status,
                document: this.current.document,
                code: this.current.code ? this.current.code : "",
				code_registration_type: this.current.code_registration_type ? this.current.code_registration_type : "",
                name: this.current.name,
                postal_code: this.current.postal_code,
                street: this.current.street.toUpperCase(),
                number: this.current.number ? this.current.number : "",
                complement: this.current.complement ? this.current.complement : "",
                neighborhood: this.current.neighborhood.toUpperCase(),
                city: this.current.city.toUpperCase(),
                uf: this.current.uf.toUpperCase(),
                country: this.current.country.toUpperCase(),
                coordinates: {
                    lat: this.current.coordinates ? this.current.coordinates.split(",")[0] : "",
                    lng: this.current.coordinates ? this.current.coordinates.split(",")[1] : "",
                },
                average_discharge_time: this.current.average_discharge_time ? this.current.average_discharge_time : "",
                phone: this.current.phone ? this.current.phone : "",
                contact_mobile: this.current.contact_mobile ? this.current.contact_mobile : "",
                contact_email: this.current.contact_email ? this.current.contact_email : "",
				discharge_timer: (this.current.discharge_timer == null) ? 0 : parseInt(this.current.discharge_timer),
				delivery_days: {
					segunda: this.current.delivery_days && this.current.delivery_days.segunda ? this.current.delivery_days.segunda : defaultDays.segunda,
					terca: this.current.delivery_days && this.current.delivery_days.terca ? this.current.delivery_days.terca : defaultDays.terca,
					quarta: this.current.delivery_days && this.current.delivery_days.quarta ? this.current.delivery_days.quarta : defaultDays.quarta,
					quinta: this.current.delivery_days && this.current.delivery_days.quinta ? this.current.delivery_days.quinta : defaultDays.quinta,
					sexta: this.current.delivery_days && this.current.delivery_days.sexta ? this.current.delivery_days.sexta : defaultDays.sexta,
					sabado: this.current.delivery_days && this.current.delivery_days.sabado ? this.current.delivery_days.sabado : defaultDays.sabado,
					domingo: this.current.delivery_days && this.current.delivery_days.domingo ? this.current.delivery_days.domingo : defaultDays.domingo
				},

				options: {
					status: {
						1: "ATIVO",
						0: "INATIVO",
					},
					code_registration_type: {
						"A": "A",
						"B": "B",
						"C": "C",
						"D": "D",
						"E": "E",
						"F": "F",
						"G": "G",
						"H": "H",
						"I": "I",
						"J": "J",
						"K": "K",
						"L": "L",
						"M": "M",
						"N": "N",
						"O": "O",
						"P": "P",
						"Q": "Q",
						"R": "R",
						"S": "S",
						"T": "T",
						"U": "U",
						"V": "V",
						"W": "W",
						"X": "X",
						"Y": "Y",
						"Z": "Z",
					},
				},
				
				client_atak: this.$api.user.company_client_atak,
			};
		}

		return {
			loading: false,
            
            id: "",
			status: "",
			document: "",
            code: "",
			code_registration_type: "",
            name: "",
            postal_code: "",
            street: "",
            number: "",
            complement: "",
            neighborhood: "",
            city: "",
            uf: "",
            country: "BRASIL",
            coordinates: null,
            average_discharge_time: "",
            phone: "",
            contact_mobile: "",
            contact_email: "",
			discharge_timer: 0,
			delivery_days: defaultDays,

			options: {
				status: {
					1: "ATIVO",
					0: "INATIVO",
				},
				code_registration_type: {
					"A": "A",
					"B": "B",
					"C": "C",
					"D": "D",
					"E": "E",
					"F": "F",
					"G": "G",
					"H": "H",
					"I": "I",
					"J": "J",
					"K": "K",
					"L": "L",
					"M": "M",
					"N": "N",
					"O": "O",
					"P": "P",
					"Q": "Q",
					"R": "R",
					"S": "S",
					"T": "T",
					"U": "U",
					"V": "V",
					"W": "W",
					"X": "X",
					"Y": "Y",
					"Z": "Z",
				},
			},
			
			client_atak: this.$api.user.company_client_atak,
		};
	},

	methods: {
        // Retorna menssagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

		// Verifica e valida inicialmente os campos
		validation: function() {
			let data = {
                id: "",
				status: "",
                document: "",
                code: "",
                code_registration_type: "",
                name: "",
                postal_code: "",
                street: "",
                number: "",
                complement: "",
                neighborhood: "",
                city: "",
                uf: "",
                country: "BRASIL",
                coordinates: null,
                average_discharge_time: "",
                phone: "",
                contact_mobile: "",
                contact_email: "",
				discharge_timer: 0,
				delivery_days: {
					segunda: [{
						start: "",
						end: "",
					}],
					terca: [{
						start: "",
						end: "",
					}],
					quarta: [{
						start: "",
						end: "",
					}],
					quinta: [{
						start: "",
						end: "",
					}],
					sexta: [{
						start: "",
						end: "",
					}],
					sabado: [{
						start: "",
						end: "",
					}],
					domingo: [{
						start: "",
						end: "",
					}],
				},
            };
			let error = false;
            
            data.id = this.id;

			if (this.status == "") {
				this.$refs.status.validate();
				this.$notification.error(this.message("STATUS"));
				error = true;
			} else {
				data.status = this.status;
			}
			
			if (this.document == "") {
				this.$refs.document.validate();
				this.$notification.error(this.message("CPF/CNPJ"));
				error = true;
			} else {
				data.document = this.document;
			}
            
            data.code = this.code;
            data.code_registration_type = this.code_registration_type;

            if (this.name == "") {
				this.$refs.name.validate();
				this.$notification.error(this.message("NOME"));
				error = true;
			} else {
				data.name = this.name;
			}

			let dataAddress = this.$refs.formGroup.validation();
			if (dataAddress) {
				data.postal_code = dataAddress.postal_code;
				data.street = dataAddress.street;
				data.number = dataAddress.number;
				data.complement = dataAddress.complement;
				data.neighborhood = dataAddress.neighborhood;
				data.city = dataAddress.city;
				data.uf = dataAddress.uf;
                data.country = dataAddress.country;
				if (dataAddress.coordinates.lat != "" && dataAddress.coordinates.lng != "") {
					data.coordinates = dataAddress.coordinates;
				} else {
					this.$notification.error("Não foi possível identificar a Latitude e Longitude, favor selecionar o endereço novamente.");
					error = true;
				}
			} else {
				error = true;
			}

            data.phone = this.phone;
            data.contact_mobile = this.contact_mobile;
            data.contact_email = this.contact_email;
            
            data.average_discharge_time = this.average_discharge_time;

			data.discharge_timer = this.discharge_timer;

			if (this.discharge_timer === 1) {
				data.delivery_days = JSON.parse(JSON.stringify(this.delivery_days));
				
				// Validação dos campos de hora
				const validateTime = (time) => {
					const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;
					return timePattern.test(time);
				};

				for (let day in data.delivery_days) {
					data.delivery_days[day].forEach((slot, index) => {
						const start = slot.start;
						const end = slot.end;

						if ((start !== "" || end !== "") && (!validateTime(start) || !validateTime(end))) {
							this.$notification.error(`Hora inválida no dia ${this.days_of_week(day)}, linha ${index + 1}`);
							error = true;
						}

						if ((start === "" && end !== "") || (start !== "" && end === "")) {
							this.$notification.error(`Ambos os campos de hora inicial e final devem ser preenchidos no dia ${this.days_of_week(day)}, linha ${index + 1}`);
							error = true;
						}
					});
				}
			}
			
			// Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return data;
            }
		},

		// Envia para API e salva as informações no BD e XML
        save: async function() {
			if (this.id) {
				let confirm = await this.$alert.confirm("Deseja mesmo EDITAR esse cliente?");
				if (!confirm) return;
			}
			
			let data = this.validation();
			
			if (data == null) {
				return;
			}

			let form = {};
			form.data = data;
			
			this.loading = true;
			let result = null;
			try {
				result = await Api.post("customer/save", form);
			} catch (ex) {
				console.log(ex);
				this.$notification.error("Não foi possível processar as informações.");
				this.loading = false;
				return;
			}
			this.loading = false;
            
            if (result) {
				if (result.error) {
					this.$notification.error(result.data);
					return;
				} else {
					this.$notification.success("Cliente cadastrado com sucesso.");
					this.close();
					this.$parent.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível processar as informações.");
				return;
			}
		},

		// Fecha o modal
		close: function() {
			this.$parent.show_modal_form = false;
			this.$parent.current_form = null;
		},

		days_of_week: function(day) {
			let days = {
				'segunda': 'Segunda-Feira',
				'terca': 'Terça-Feira',
				'quarta': 'Quarta-Feira',
				'quinta': 'Quinta-Feira',
				'sexta': 'Sexta-Feira',
				'sabado': 'Sábado',
				'domingo': 'Domingo',
			}

			return days[day];
		},

		add_timer: function(day) {
			let new_timer = {
				start: "",
				end: "",
			}

			this.delivery_days[day].push(new_timer);
		},

		remove_timer: function(day, index) {
			this.delivery_days[day].splice(index, 1);
		},
	}
}
</script>

<style scoped>
.add-new-product {
	margin-top: 10px;
	border: none;
	background: #000;
	color: #d9d9d9;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
}

.remove-product {
	float: right;
	background-color: red;
	color: #fff;
	font-weight: 700;
	font-size: 12px;
	border: none;
	padding: 5px 15px;
}

.order-list-products {
	margin-bottom: 15px;
	border: 1px solid black;
}

.order-list-products-item {
	padding: 10px;
	border-top: 1px solid black;
	border-bottom: 1px solid black;
}

.d-flex {
	display: flex;
}

.justify-between {
	justify-content: space-between;
}

.fas.fa-plus,
.fas.fa-times {
	cursor: pointer;
}
</style>